import React from "react";
// react plugin used to create google maps
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker,
// } from "react-google-maps";
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components
// const MapWrapper = withScriptjs(
//   withGoogleMap((props) => (
//     <GoogleMap
//       defaultZoom={14}
//       defaultCenter={{ lat: 44.445248, lng: 26.099672 }}
//       defaultOptions={{
//         styles: [
//           {
//             featureType: "water",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#e9e9e9",
//               },
//               {
//                 lightness: 17,
//               },
//             ],
//           },
//           {
//             featureType: "landscape",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#f5f5f5",
//               },
//               {
//                 lightness: 20,
//               },
//             ],
//           },
//           {
//             featureType: "road.highway",
//             elementType: "geometry.fill",
//             stylers: [
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 17,
//               },
//             ],
//           },
//           {
//             featureType: "road.highway",
//             elementType: "geometry.stroke",
//             stylers: [
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 29,
//               },
//               {
//                 weight: 0.2,
//               },
//             ],
//           },
//           {
//             featureType: "road.arterial",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 18,
//               },
//             ],
//           },
//           {
//             featureType: "road.local",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 16,
//               },
//             ],
//           },
//           {
//             featureType: "poi",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#f5f5f5",
//               },
//               {
//                 lightness: 21,
//               },
//             ],
//           },
//           {
//             featureType: "poi.park",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#dedede",
//               },
//               {
//                 lightness: 21,
//               },
//             ],
//           },
//           {
//             elementType: "labels.text.stroke",
//             stylers: [
//               {
//                 visibility: "on",
//               },
//               {
//                 color: "#ffffff",
//               },
//               {
//                 lightness: 16,
//               },
//             ],
//           },
//           {
//             elementType: "labels.text.fill",
//             stylers: [
//               {
//                 saturation: 36,
//               },
//               {
//                 color: "#333333",
//               },
//               {
//                 lightness: 40,
//               },
//             ],
//           },
//           {
//             elementType: "labels.icon",
//             stylers: [
//               {
//                 visibility: "off",
//               },
//             ],
//           },
//           {
//             featureType: "transit",
//             elementType: "geometry",
//             stylers: [
//               {
//                 color: "#f2f2f2",
//               },
//               {
//                 lightness: 19,
//               },
//             ],
//           },
//           {
//             featureType: "administrative",
//             elementType: "geometry.fill",
//             stylers: [
//               {
//                 color: "#fefefe",
//               },
//               {
//                 lightness: 20,
//               },
//             ],
//           },
//           {
//             featureType: "administrative",
//             elementType: "geometry.stroke",
//             stylers: [
//               {
//                 color: "#fefefe",
//               },
//               {
//                 lightness: 17,
//               },
//               {
//                 weight: 1.2,
//               },
//             ],
//           },
//         ],
//         scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
//       }}
//     >
//       <Marker position={{ lat: 44.445248, lng: 26.099672 }} />
//     </GoogleMap>
//   ))
// );

function SectionContactUs() {
  return (
    <>
        {/* ********* CONTACT US 1 ********* */}
        <div
          className="contactus-1 section-image"
          style={{
            backgroundImage:
              "url(" + require("assets/img/dots.gif") + ")",
          }}
        >
          <Container>
            <Row>
              <Col className="ml-auto mr-auto" md="10">
                <Card className="card-contact no-transition">
                  <CardTitle className="text-center" tag="h3">
                    Contact Us
                  </CardTitle>
                  <Row>
                 
                    <Col className="mr-auto" md="10">
                    <Form
                      className="p-3"
                      action="https://postmail.invotes.com/send"
                      method="post"
                      id="contact_form"
                      role="form"
                    >
                          <input
                      type="hidden"
                      name="access_token"
                      value="j5gyyeo86ing8s64kdbswki3"
                    />
                      <input
                      type="hidden"
                      name="success_url"
                      value=".?message=Email+Successfully+Sent%21&isError=0"
                    />
                    <input
                      type="hidden"
                      name="error_url"
                      value=".?message=Email+could+not+be+sent.&isError=1"
                    />
                        <CardBody>
                          <Row>
                            <Col md="10">
                              <FormGroup className="label-floating">
                                <label className="control-label">
                                  Full name
                                </label>
                                <Input
                                  placeholder="Full Name"
                                  type="text"
                                  name="subject"
                                />
                              </FormGroup>
                            </Col>
                           
                          </Row>
                          <FormGroup className="label-floating">
                            <label className="control-label">
                              Email address
                            </label>
                            <Input
                               name="text"
                              placeholder="Email"
                              type="email"
                            />
                          </FormGroup>
                          <FormGroup className="label-floating">
                            <label className="control-label">
                              Your message
                            </label>
                            <Input
                              id="message"
                              name="extra_Message"
                              placeholder="Message"
                              type="textarea"
                              rows="6"
                            />
                          </FormGroup>
                          <Row>
                            <Col md="10">
                              <FormGroup check>
                                <Label check>
                                  <Input defaultValue="" type="checkbox" />
                                  I'm not a robot !{" "}
                                  <span className="form-check-sign" />
                                </Label>
                              </FormGroup>
                            </Col>
                            <Col md="10">
                            <input
                        type="hidden"
                        name="access_token"
                        value="fmin2luwi0f9iujitblnnpr6"
                      />
                              <Button
                                className="pull-right"
                                color="primary"
                                type="submit"
                              id="submit_form"
                              >
                                Send Message
                              </Button>
                            </Col>
                          </Row>
                        </CardBody>
                      </Form>
                    </Col>
                  </Row>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        {/* ********* END CONTACT US 1 ********* */}
      
    </>
  );
}

export default SectionContactUs;
